import React from "react";
import StackTrace from "stacktrace-js";

interface Props {
    error: Error | string;
    info?: React.ErrorInfo | string;
}

export default function ErrorRenderer({ error }: Props) {
    const [html, setHtml] = React.useState(typeof error === "string" ? error : error.stack);

    React.useEffect(() => {
        if (typeof error === "object") {
            StackTrace.fromError(error).then((stackframes) => {
                setHtml(
                    `${error.name}: ${error.message}\n${stackframes
                        .map((sf) => `    at ${sf.toString()}`)
                        .join("\n")}`,
                );
            });
        }
    }, [error]);

    return (
        <div className="survey-engine__error">
            <pre
                className="survey-engine__error__stack"
                dangerouslySetInnerHTML={{ __html: html }}
            />
        </div>
    );
}
